import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontSize: 12,
    body2: {
      fontSize: "0.75rem",
    },
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: "0.75rem",
          paddingTop: 8,
          paddingBottom: 8,
        },
        head: {
          fontWeight: 600,
          fontSize: "0.75rem",
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          fontSize: "0.75rem",
        },
      },
    },
  },
});

export default theme;
